<template>
  <div>
    <base-modal v-for="modal in modals" :modal="modal" :key="modal.id">
      <component :is="modal.name" :modal="modal"></component>
    </base-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { modalHandler } from '../../../utils/vue/modalHandler';

export default {
  name: 'modal-handler',
  data() {
    return {};
  },

  mounted() {},
  created() {},
  methods: {},
  computed: {
    ...mapGetters({}),
    modals() {
      return modalHandler.modals.value;
    },
  },
  watch: {},
  components: {},
};
</script>
ú
